// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__2RD1b","consentsList":"PatientConsents_consentsList__G5mZe","consentsListEmpty":"PatientConsents_consentsListEmpty__3VsSG"};